import * as React from "react"

import classNames from "@molnx-sites/common/utils/classNames"

import styles from "./SideNavigation.module.scss"

interface Props {
    className?: string
    children?: any
}

function SideNavigation1(props: Props) {
    const className = classNames(
        styles.SideNavigation,
        props.className
    )

    return (
        <div className={className}>
            {props.children}
        </div>
    )
}

export const SideNavigation = Object.assign(
    SideNavigation1,
    {
        Classes: {
            ActiveLink: styles.ActiveLink
        }
    }
)